<template>
    <section :class="size" class="ui-input ui-input-group ui-box-search">
        <input
            v-if="mask"
            v-model="value"
            v-mask="mask"
            :placeholder="placeholder"
            :disabled="disabled"
            :style="{'background': bgColor, 'color': placeholderColor}"
            type="text"
            class="input"
            autocomplete="off"
            @input="onInput"
            @blur="onBlur"
            @keydown.enter.prevent="sendText()" />

        <input
            v-else
            v-model="value"
            :placeholder="placeholder"
            :disabled="disabled"
            :style="{'background': bgColor, 'color': placeholderColor}"
            type="text"
            class="input"
            autocomplete="off"
            @input="onInput"
            @blur="onBlur"
            @keydown.enter.prevent="sendText()" />

        <button v-if="!status" :disabled="disabledButton" class="group" type="button" @click="sendText()">
            <slot name="label"><i class="far fa-search"/></slot>
        </button>
        <button v-if="status" :disabled="disabledButton" class="group" type="button" @click="sendClear()">
            <slot name="label"><i class="fal fa-times"/></slot>
        </button>
    </section>
</template>

<script>
    import { mask } from 'vue-the-mask'
    export default {
        name: 'search-box',
        directives: {
            mask
        },
        props: {
            /**
			 * Utilize para acessar o valor do input
			 */
            event: {
                type: String,
                required: false,
                default: 'search-box',
            },
            placeholder: {
                type: String,
                required: false,
                default: 'Buscar formulário',
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
            disabledButton: {
                type: Boolean,
                required: false,
                default: false,
            },
            /**
			 * Utilize para alterar o tamanho do input
			 */
            size: {
                type: String,
                required: false,
                default: 'md'
            },
            /**
			 * Utilize para aplicar mask no input
			 */
            mask: {
                type: String,
                required: false,
                default: ''
            },
            /**
			 * Utilize para aplicar background no input
			 */
			bgColor: {
				type: String,
				default: '#ffffff'
			},
            /**
			 * Utilize para aplicar color no placeholder
			 */
			placeholderColor: {
				type: String,
				default: '#4a586c'
			},
            /**
			 * Utilize para limpar o texto ao enviar
			 */
             clearTextWhenSending: {
				type: Boolean,
				default: false
			},
        },
        data() {
            return {
                status: false,
                value: '',
                loading: false
            }
        },
        mounted() {
            this.$root.$on(this.event + '-reset', () => {
                this.resetInput()
            })
            this.$root.$on('ui-search-box-loading-true', this.setLoadingTrue)
            this.$root.$on('ui-search-box-loading-false', this.setLoadingFalse)
        },

        beforeDestroy() {
            this.$root.$off(this.event + '-reset')
            this.$root.$off('ui-search-box-loading-true', this.setLoadingTrue)
            this.$root.$off('ui-search-box-loading-false', this.setLoadingFalse)
        },
        methods: {
            setLoadingTrue() {
                this.loading = true
            },
            setLoadingFalse() {
                this.loading = false
            },
            sendText() {
                if(this.loading) return;
                this.status = true
                this.$emit('input', this.value)
                this.$root.$emit(this.event, this.value)
                if(this.clearTextWhenSending){
                    this.value = ''
                }
            },
            sendClear() {
                this.status = false
                this.value = ''
                this.$emit('input', this.value)
                this.$root.$emit(this.event, this.value)
            },
            onInput(event) {
                this.status = false
                this.$emit('input', event.target.value)
            },
            onBlur() {
                this.$emit('blur', event.target.value)
            },
            resetInput() {
                this.value = ''
            },
        },
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>
